import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Platform,
} from "react-native";

//import PhotoUpload from "react-native-photo-upload";

import AppConfig from "../../../config/AppConfig";
import Header from "../common/header";
import React from "react";
import ImageComponent from "../common/ImageComponent";
import ManaTextInput from "../common/ManaTextInput";
import appStyles from "../../appStyles";
import Icons from "../common/icons/index";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import AppTheme from "../AppTheme";
import { hasItems, navigate } from "../../../helpers/utils";
import fontStyles from "../../fonts";
import appPages from "../../../appPages";
import DeleteAccountDialog from "./profile/DeleteAccountDialog";

export default class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const { has_scheduled_call, tutorials = {} } =
      this.controller.state?.settings || {};

    const badges = []; /*TutorialsHelper.getTutorialsList({
      has_scheduled_call,
      ...tutorials,
    });*/

    this.state = {
      badges,
      avatar: this.controller.state?.picture,
      email:
        this.controller.state?.settings?.email_edited ||
        this.controller.state?.impersonate ||
        this.controller.state?.currentUser,
      name: this.controller.state?.settings?.nickname,
    };
  }

  updateProfile = (key, value) => {
    if (!value) return;

    this.setState((state) => ({ ...state, [key]: value }));
    this.saveProfile({ [key]: value });
  };

  saveProfile = (data) => {
    const action = {
      action: "save",
      target: "profile",
      ...data,
    };

    this.setState((state) => ({ ...state, isLoading: true }));

    console.log("Save Profile");
    this.controller.cardActionWithCallback(action, () => {
      this.setState((state) => ({ ...state, isLoading: false }));
    });
  };

  onPhotoSelect = () => {
    const options = {
      noData: true,
    };
    ImagePicker.launchImageLibrary(options, (response) => {
      if (response.uri) {
        this.setState((state) => ({ ...state, avatar: response }));
      }
    });
  };

  toggleDialog = (isDialogOpen) => {
    this.setState((state) => ({ ...state, isDialogOpen }));
  };

  deleteAccount = () => {
    const { email, name } = this.state;

    const action = {
      action: "save",
      target: "account",
      operation: "delete",
      email,
      name,
    };

    this.setState((state) => ({ ...state, isLoading: true }));

    console.log("Delete Account");
    this.controller.cardActionWithCallback(action, () => {
      this.setState(
        (state) => ({
          ...state,
          isLoading: false,
          isDialogOpen: null,
        }),
        () => {
          this.controller.logout();
        },
      );
    });
  };

  render() {
    const { name, email, avatar, isLoading, badges, isDialogOpen } = this.state;

    return (
      <View style={appStyles.container}>
        <Header
          title="Profile"
          hideAvatar
          goBack={() => this.controller.goBack()}
          controller={this.controller}
          isLoading={isLoading}
        />

        {isDialogOpen ? (
          <DeleteAccountDialog
            controller={this.controller}
            close={() => this.toggleDialog(null)}
            onContinue={this.deleteAccount}
          />
        ) : null}

        <View style={styles.content}>
          {/* Name */}
          <View style={styles.row}>
            <Text style={styles.label}>Name</Text>

            <ManaTextInput
              placeholderTextColor="#9C9EB9"
              autoFocus={false}
              name={"profileName"}
              placeholder=" What should we call you?"
              onTextChanged={(text) => this.updateProfile("name", text)}
              value={name || ""}
              style={styles.input}
            />
          </View>

          {/* Email */}
          <View style={styles.row}>
            <Text style={styles.label}>Email</Text>
            <ManaTextInput
              placeholderTextColor="#9C9EB9"
              autoFocus={false}
              name={"profileEmail"}
              placeholder="Email"
              onTextChanged={(text) => this.updateProfile("email", text)}
              value={email || ""}
              style={styles.input}
            />
          </View>

          {/* <PhotoUpload onPhotoSelect={this.onPhotoSelect}>
            <Image
              style={{
                paddingVertical: 30,
                width: 150,
                height: 150,
                borderRadius: 75,
              }}
              resizeMode="cover"
              source={avatar}
            />
          </PhotoUpload> */}

          {avatar ? (
            <View style={[styles.imageContainer]}>
              <ImageComponent styles={styles.avatar} image={avatar} />
              {/* <Text style={styles.avatarText}>Change Profile Photo</Text> */}
            </View>
          ) : null}

          <Text
            style={[fontStyles.subtitleBold, styles.deleteLink]}
            onPress={() => this.toggleDialog(true)}
          >
            Delete Account
          </Text>

          {/* Badges */}
          {hasItems(badges) ? (
            <View style={{ marginTop: 20 }}>
              <View style={[styles.badgeRow]}>
                <Icons.Favorite color={AppTheme.almostBlack} />
                <Text style={styles.badgesHeader}>Badges</Text>
              </View>

              <View
                style={[styles.badgeRow, { justifyContent: "space-between" }]}
              >
                {badges.map((b, index) => (
                  <TouchableOpacity
                    key={index}
                    onPress={() =>
                      TutorialsHelper.onTutorialClicked(this.controller, b)
                    }
                  >
                    <b.badgeIcon
                      style={styles.badgeIcon}
                      opacity={b.isComplete ? 1 : 0.3}
                      onPress={() =>
                        TutorialsHelper.onTutorialClicked(this.controller, b)
                      }
                    />
                    <Text
                      style={[
                        styles.badgeText,
                        !b.isComplete ? styles.badgeTextIncomplete : {},
                      ]}
                    >
                      {b.badgeText}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
            </View>
          ) : null}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 15,
    flex: 1,
    backgroundColor: "#FFFF",
    paddingTop: 10,
  },
  row: {
    width: "100%",
    height: 44,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 10,
  },
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
    width: 72,
  },
  value: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: "#2D3142",
  },
  nickname: {
    color: "#768B9D",
  },
  input: {
    width: "100%",
    elevation: 3,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: "#2D3142",
    marginBottom: 0,
    shadowOpacity: 0,
    flex: 1,
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 12,
  },
  avatar: {
    width: 160,
    height: 160,
    borderRadius: 80,
  },
  avatarText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.DEFAULT_COLOR,
    marginTop: 12,
  },
  badgeRow: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 5,
  },
  badgesHeader: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  badgeIcon: {
    opacity: 0.8,
    width: 86,
    height: 86,
  },
  badgeText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: "#41D3B0",
    textAlign: "center",
  },
  badgeTextIncomplete: {
    color: AppTheme.almostBlack,
    opacity: 0.3,
  },
  deleteLink: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 32,
    color: "#DD5F43",
  },
});
